import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { AGENTEKEYWORD, USERID, TOKEN } from '../../_helpers/token';

export class WinnerSelect extends React.Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            amount: 0,
            showError: false,
            email_address: '',
            userDetail: false,
            isShowError: false,
        }
    }

    onSubmit(e) {
        e.preventDefault();

        if (window.confirm('Are you sure you want to run this draw?')) {

            if (this.state.amount > 0) {
                this.setState({ isLoading: true });

                axios.get(baseURL + `draw_run?presenter=${AGENTEKEYWORD}&id=${USERID}&amount=${this.state.amount}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                }).then((response) => {
                    // console.log("bayo", response.data)
                    // alert("Feedback send");
                    if (response.data.status) {

                        this.setState({
                            statusMessage: "SUCCESS!!",
                            isShowError: true, isLoading: false, showError: false,
                        });


                        
                        alert("Winner is: " + response.data.msisdn)

                    } else {

                        this.setState({ statusMessage: response.data.message, email_address: '', userDetail: false, showError: true, isShowError: false, isLoading: false });
                    }
                }).catch(error => {
                    console.log('bayoo', error.response)
                    this.setState({
                        showError: true,
                        isShowError: false,
                        phone_number: '',
                        email_address: '',
                        userDetail: false,
                        statusMessage: error.response.data.message,
                        submitted: true,
                        isLoading: false
                    });
                });
            }else{
                alert('invalid amount')
            }
        }


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent, userDetail } = this.state;

        return (
            <div className="pcoded-main-container">
                {userDetail === true ? <Redirect to='userdetail' /> : null}
                {showComponent && (
                    <div>
                        {this.state.showComponent ?
                            <peopleView /> : null
                        }
                    </div>
                )}
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody >
                                    <div className="card__title">
                                        <h5 className="bold-text">Run Draw</h5>
                                    </div>



                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}
                                    </div> : null}<br></br>
                                    {this.state.isShowError ? (
                                        <div color="success" style={{ fontSize: "13px", color: "green" }}>

                                            {this.state.statusMessage}

                                        </div>
                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>

                                        <div className='col-6 offset-3'>
                                            <span className="form__form-group-label">Enter Amount   </span>

                                            <div className="form__form-group-field">
                                                <input
                                                    required
                                                    type='number'
                                                    className="form-control"
                                                    placeholder="Enter amount"
                                                    name="amount"
                                                    id="input"
                                                    value={this.state.amount}
                                                    onChange={e => this.setState({ amount: e.target.value })} />
                                            </div>

                                            <div className="col-12 center">
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <Button outline type="submit" color="primary" className="float-right" >
                                                    {this.state.isLoading ? "Running Please Wait..." : "Start Now"}
                                                </Button> &nbsp;&nbsp;&nbsp;
                                            </div>

                                        </div>
                                    </form>

                                </CardBody>


                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
